var _circle, _g, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 93,
    viewBox: "0 0 101 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.766,
    cy: 46.3501,
    r: 46.123,
    fill: "#EEF0F2",
    stroke: "#EAEAEA",
    strokeWidth: 0.452282
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_1375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7663 13.2551C37.8936 13.2551 30.634 20.7405 30.634 29.9636C30.634 39.1867 37.8936 46.6721 46.7663 46.6721C55.6391 46.6721 62.8986 39.1867 62.8986 29.9636C62.8986 20.7405 55.6391 13.2551 46.7663 13.2551ZM29.9081 46.6721C21.3579 47.0062 14.5017 52.8208 14.5017 60.0388V66.7222H79.0309V60.0388C79.0309 52.8208 72.2554 47.0062 63.6246 46.6721C59.2689 50.7489 53.2999 53.3554 46.7663 53.3554C40.2327 53.3554 34.2638 50.7489 29.9081 46.6721Z",
    fill: "#8D8D8D",
    fillOpacity: 0.5
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.041,
    cy: 73.887,
    r: 14.5027,
    fill: "#EEF0F2",
    stroke: "white",
    strokeWidth: 1.08819
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6022 65.713C87.1655 65.1488 88.0792 65.1485 88.643 65.7123L91.3379 68.4072C91.8969 68.9661 91.9027 69.871 91.3509 70.4371L89.5512 72.2836L84.7928 67.5252L86.6022 65.713ZM84.0278 68.2913L88.7955 73.059L82.7437 79.2682C82.3362 79.6862 81.7775 79.922 81.194 79.9219L78.2644 79.9218C77.6488 79.9218 77.1572 79.4086 77.1831 78.7931L77.3078 75.8291C77.3306 75.2869 77.556 74.773 77.9393 74.389L84.0278 68.2913ZM92.127 80.3986C92.4259 80.3986 92.6682 80.1561 92.6682 79.857C92.6682 79.5579 92.4259 79.3154 92.127 79.3154H86.6737C86.3749 79.3154 86.1326 79.5579 86.1326 79.857C86.1326 80.1561 86.3749 80.3986 86.6737 80.3986H92.127Z",
    fill: "#BDBFBF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_1375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.5292,
    height: 53.4671,
    fill: "white",
    transform: "translate(14.5017 13.2551)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default_profile.b78d3a3f37252bf94e9717a4b4b36da0.svg";
export { ForwardRef as ReactComponent };